module.exports = __webpack_public_path__ + "static/media/Chair2_After.f76762bc.jpg";